/* cart.js */

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (!cartItems) return;
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value || '0', 10), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    const idx = event.target?.dataset?.index;
    const val = event.target?.value;
    const activeName = document.activeElement ? document.activeElement.getAttribute('name') : null;
    this.updateQuantity(idx, val, activeName);
  }

  // Sections list for full page cart
  getSectionsToRender() {
    const mainItems = document.getElementById('main-cart-items');
    const mainFooter = document.getElementById('main-cart-footer');
    return [
      mainItems
        ? { id: 'main-cart-items', section: mainItems.dataset.id, selector: '.js-contents' }
        : null,
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      mainFooter
        ? { id: 'main-cart-footer', section: mainFooter.dataset.id, selector: '.js-contents' }
        : null
    ].filter(Boolean);
  }

  updateQuantity(line, quantity, name) {
    if (!line) return;

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) {
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        }
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        this.getSectionsToRender().forEach((section) => {
          const host =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          host.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && name) {
          const focusable = lineItem.querySelector(`[name="${name}"]`);
          if (focusable) {
            const cartDrawerWrapperNow = document.querySelector('cart-drawer');
            if (cartDrawerWrapperNow) {
              trapFocus(cartDrawerWrapperNow, focusable);
            } else {
              focusable.focus();
            }
          }
        } else {
          const cartDrawerWrapperNow = document.querySelector('cart-drawer');
          if (parsedState.item_count === 0 && cartDrawerWrapperNow) {
            const emptyContainer = cartDrawerWrapperNow.querySelector('.drawer__inner-empty');
            const firstLink = emptyContainer ? emptyContainer.querySelector('a') : null;
            if (emptyContainer && firstLink) trapFocus(emptyContainer, firstLink);
          } else if (document.querySelector('.cart-item') && cartDrawerWrapperNow) {
            const firstName = document.querySelector('.cart-item__name');
            if (firstName) trapFocus(cartDrawerWrapperNow, firstName);
          }
        }

        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      if (lineItemError && quantityElement) {
        const msg = window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
        const holder = lineItemError.querySelector('.cart-item__error-text');
        if (holder) holder.innerHTML = msg;
      }
    }

    this.currentItemCount = itemCount;
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return;

    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

    const cartItemEls = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerEls = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
    [...cartItemEls, ...cartDrawerEls].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement) document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
  }
}
customElements.define('cart-items', CartItems);

// Expose for cart-drawer.js bootstrap
window.CartItems = CartItems;

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  });
}
